import axios from "axios";

axios.defaults.baseURL = `${process.env.API_URL}`; // the prefix of the URL
axios.defaults.headers.get["Accept"] = "application/json"; // default header for all get request
axios.defaults.headers.get["Content-Type"] = "application/json"; // default header for all get request
axios.defaults.headers.post["Accept"] = "application/json"; // default header for all POST request

export default axios;
